import { render, staticRenderFns } from "./itemsInvesstorList.vue?vue&type=template&id=7763a472&scoped=true&"
import script from "./itemsInvesstorList.vue?vue&type=script&lang=js&"
export * from "./itemsInvesstorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7763a472",
  null
  
)

export default component.exports